
















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import UserType from "../types/user";

@Component
export default class NewUserDialog extends Vue {
  @Prop() userData!: UserType;

  @Prop() onSubmit: (value: UserType) => void;

  isDialogOpen = false;

  currentUser = this.userData || {
    name: "",
    email: "",
    age: null,
  };

  close() {
    console.log(this.userData);
    this.isDialogOpen = false;
  }

  save() {
    console.log("saved with", this.currentUser);
    this.$emit("submit", this.currentUser);
  }
}
